module.exports = __webpack_public_path__ + "img/bonus_symbol_1.7a34c015.png";